import React, { useState } from 'react';
import { leadAPI } from '../services/api';
import './NoteButton.css';

const NoteButton = ({ leadId, customerName, onNoteAdded }) => {
  const [showModal, setShowModal] = useState(false);
  const [noteContent, setNoteContent] = useState('');
  const [loading, setLoading] = useState(false);

  const handleOpen = (e) => {
    e.stopPropagation(); // Stop row click events
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setNoteContent('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!noteContent.trim()) {
      alert('Please enter a description');
      return;
    }
    
    try {
      setLoading(true);
      await leadAPI.addNote(leadId, { content: noteContent, isImportant: false });
      alert('Note saved successfully!');
      handleClose();
      if (onNoteAdded) onNoteAdded();
    } catch (error) {
      console.error('Error saving note:', error);
      alert('Failed to save note');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button 
        type="button" 
        className="btn-note-action" 
        onClick={handleOpen}
        title="Add Quick Note / Description"
      >
        📝
      </button>

      {showModal && (
        <div className="note-modal-overlay" onClick={(e) => { e.stopPropagation(); handleClose(); }}>
          <div className="note-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="note-modal-header">
              <h3>Add Note / Description</h3>
              <button className="note-close-btn" onClick={handleClose}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="note-modal-body">
                <p className="note-lead-name">Lead: <strong>{customerName}</strong></p>
                <div className="form-group">
                  <label>Select Talk Description / Note</label>
                  <select 
                    onChange={(e) => setNoteContent(e.target.value)}
                    value={[
                      'Follow-up',
                      'Not Pick Up',
                      'Not Interested',
                      'Interested',
                      'Switch Off',
                      'Invalid',
                      'Busy',
                      'Call Cut'
                    ].includes(noteContent) ? noteContent : ''}
                    style={{ 
                      marginBottom: '15px', 
                      width: '100%', 
                      padding: '10px 12px', 
                      borderRadius: '5px', 
                      border: '1px solid #ddd',
                      fontSize: '14px',
                      backgroundColor: 'white',
                      cursor: 'pointer'
                    }}
                  >
                    <option value="">-- Choose from standard options --</option>
                    <option value="Follow-up">Follow-up</option>
                    <option value="Not Pick Up">Not Pick Up</option>
                    <option value="Not Interested">Not Interested</option>
                    <option value="Interested">Interested</option>
                    <option value="Switch Off">Switch Off</option>
                    <option value="Invalid">Invalid</option>
                    <option value="Busy">Busy</option>
                    <option value="Call Cut">Call Cut</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Enter Talk Description / Customize Note *</label>
                  <textarea
                    value={noteContent}
                    onChange={(e) => setNoteContent(e.target.value)}
                    placeholder="e.g. Discussed EV options, customer wants a home delivery check..."
                    rows="5"
                    required
                    autoFocus
                  />
                </div>
              </div>
              <div className="note-modal-footer">
                <button type="button" className="note-btn note-btn-cancel" onClick={handleClose}>
                  Cancel
                </button>
                <button type="submit" className="note-btn note-btn-save" disabled={loading}>
                  {loading ? 'Saving...' : 'Save Note'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default NoteButton;
